export default function authHeaderBearer() {
  const assistant = JSON.parse(localStorage.getItem('assistant'));
  const user      = JSON.parse(localStorage.getItem('user'));

  if (assistant && assistant.auth_token) {
    return { Authorization: assistant.auth_token };
  } else if (user && user.auth_token) {
    return { Authorization: user.auth_token };
  } else {
    return {};
  }
}